import {
  ADD_CANDIDATE,
  ADD_CANDIDATE_FAILED,
  ADD_CANDIDATE_SUCCESS,
  CLOSE_JOB,
  CLOSE_JOB_FAILED,
  CLOSE_JOB_SUCCESS,
  DELETE_CANDIDATE_ON_CANDIDATEPOOL,
  DELETE_CANDIDATE_ON_CANDIDATEPOOL_FAILED,
  DELETE_CANDIDATE_ON_CANDIDATEPOOL_SUCCESS,
  DELETE_MAPPED_JOB_CANDIDATE,
  DELETE_MAPPED_JOB_CANDIDATE_ERROR,
  DELETE_MAPPED_JOB_CANDIDATE_SUCCESS,
  EXTEND_JOB,
  EXTEND_JOB_FAILED,
  EXTEND_JOB_SUCCESS,
  GET_MAPPED_JOB_CANDIDATE_DETAIL,
  GET_MAPPED_JOB_CANDIDATE_DETAIL_ERROR,
  GET_MAPPED_JOB_CANDIDATE_DETAIL_SUCCESS,
  GET_MATCHED_CANDIDATE_DETAIL,
  GET_MATCHED_CANDIDATE_DETAIL_ERROR,
  GET_MATCHED_CANDIDATE_DETAIL_SUCCESS,
  GET_MATCHING_CANDIDATE,
  GET_MATCHING_CANDIDATE_ERROR,
  GET_MATCHING_CANDIDATE_SUCCESS,
  GET_MATCHING_JOB_BOARD_CANDIDATE,
  GET_MATCHING_JOB_BOARD_CANDIDATE_SUCCESS,
  GET_SELECTED_JOB_DETAIL,
  GET_SELECTED_JOB_DETAIL_ERROR,
  GET_SELECTED_JOB_DETAIL_SUCCESS,
  GET_SIMILAR_JOB_DETAIL,
  GET_SIMILAR_JOB_DETAIL_ERROR,
  GET_SIMILAR_JOB_DETAIL_SUCCESS,
  GOOGLE_JOB_DETAILS,
  GOOGLE_JOB_DETAILS_FAILED,
  GOOGLE_JOB_DETAILS_SUCCESS,
  JOB_LISTING_SUGGESTIONS,
  JOB_LISTING_SUGGESTIONS_FAILED,
  JOB_LISTING_SUGGESTIONS_SUCCESS,
  JOB_STATUS,
  JOB_STATUS_FAILED,
  JOB_STATUS_SUCCESS,
  OTHER_JOB_DETAILS,
  OTHER_JOB_DETAILS_FAILED,
  OTHER_JOB_DETAILS_SUCCESS,
  POST_POPUP_DATA,
  POST_POPUP_DATA_FAIL,
  POST_POPUP_DATA_SUCCESS,
  SEND_CANDIDATE_INTEREST_REMINDER,
  SEND_CANDIDATE_INTEREST_REMINDER_FAILED,
  SEND_CANDIDATE_INTEREST_REMINDER_SUCCESS,
  SET_MAPPED_JOB_CANDIDATE_DETAIL,
  SET_MAPPED_JOB_CANDIDATE_DETAIL_ERROR,
  SET_MAPPED_JOB_CANDIDATE_DETAIL_SUCCESS,
  UPDATE_MAPPED_CANDIDATE,
  UPDATE_MAPPED_CANDIDATE_ERROR,
  UPDATE_MAPPED_CANDIDATE_SUCCESS,
  VIEW_JOB,
  VIEW_JOB_ERROR,
  VIEW_JOB_SUCCESS,
  GENERATE_MATCHING_SCORE_SUCCESS,
  GENERATE_MATCHING_SCORE_ERROR,
  GET_DEFAULT_WEIGHTAGE,
  GET_DEFAULT_WEIGHTAGE_SUCCESS,
  GET_DEFAULT_WEIGHTAGE_ERROR,
  GET_CUSTOM_WEIGHTAGE,
  GET_CUSTOM_WEIGHTAGE_SUCCESS,
  GET_CUSTOM_WEIGHTAGE_ERROR,
  SAVE_CUSTOM_WEIGHTAGE,
  SAVE_CUSTOM_WEIGHTAGE_SUCCESS,
  SAVE_CUSTOM_WEIGHTAGE_ERROR,
  GET_FILTERED_JOB_BOARD_CANDIDATES_ERROR,
  GET_FILTERED_JOB_BOARD_CANDIDATES_SUCCESS,
  GET_FILTERED_JOB_BOARD_CANDIDATES,
  GET_CANDIDATE_FACETS_ERROR,
  GET_JOB_BASED_FACETS,
  GET_JOB_BASED_FACETS_SUCCESS,
  GET_JOB_BASED_FACETS_ERROR,
  GET_CANDIDATE_FACETS_SUCCESS,
  GET_CANDIDATE_FACETS,
  GENERATE_BULK_MATCHING_SCORE_SUCCESS,
  GENERATE_BULK_MATCHING_SCORE_ERROR,
  BULK_MAP_CANDIDATES_TO_JOB,
  BULK_MAP_CANDIDATES_TO_JOB_SUCCESS,
  BULK_MAP_CANDIDATES_TO_JOB_ERROR,
} from "./actionTypes";

const initialState = {
  loading: false,
  viewJobData: null,
  viewJobError: null,
  matchingJobData: null,
  // state for matching candiate data job board
  matchingJobBoardCandidateData: null,
  matchingJobError: null,
  matchedCandidateData: null,
  matchedCandidateError: null,
  similarJobsData: null,
  similarJobsError: null,
  similarSelectedJobsData: null,
  similarSelectedJobsError: null,
  mappedJobCandidate: null,
  mappedJobCandidateError: null,
  deleteCandidate: null,
  deleteMappedCandidateError: null,
  setMappedCandidateDetail: null,
  setMappedCandidateError: null,
  updateMappedSuccess: null,
  matchingCandidateLoader: false,
  //matching candidate loader for job board candidate
  matchingJobBoardCandidateLoader: false,
  mappedCandidateLoader: false,
  similarJobLoader: false,
  updateCandidateStatus: false,
  candidateListData: null,
  candidateListDataError: null,
  extendJobSuccess: null,
  extendJobFailed: null,
  closeJObSuccess: null,
  closeJobError: null,
  otherJobDetails: null,
  otherJobDetailsFailed: null,
  googleJobsData: null,
  googleJobdetailsFailed: null,
  addCandidateSuccessMsg: null,
  addCandidateErrorMsg: null,
  jobTableSuggestionSuccess: null,
  jobTableSuggestionFailed: null,
  candidateDetailLoader: false,
  jobActive: null,
  jobStatusError: null,
  requiredFieldData: null,
  requiredFieldError: null,
  popupdata: null,
  erromsg: null,
  reminder: null,
  erroRemindermsg: null,
  candidateDeleteSucess: null,
  candidateerrormsg: null,
  generateScoreSuccessMsg: null,
  generateScoreErr: null,
  defaultWeightage: null,
  customWeightage: null,
  weightageLoading: false,
  saveWeightageSuccess: null,
  saveWeightageError: null,
  candidateFacets: null,
  facetsLoading: false,
  facetsError: null,
  jobBasedFacets: null,
  jobBasedFacetsLoading: false,
  jobBasedFacetsError: null,
  filteredCandidates: null,
  filteredCandidatesLoading: false,
  filteredCandidatesError: null,
  generateBulkScoreSuccessMsg: null,
  generateBulkScoreErr: null,
  bulkMapCandidatesLoading: false,
  bulkMapCandidatesSuccess: null,
  bulkMapCandidatesError: null,
};

const viewJobReducer = (state = initialState, action) => {
  switch (action.type) {
    //view viewJob
    case VIEW_JOB:
      state = {
        ...state,
        loading: true,
        viewJobError: null,
        extendJobSuccess: null,
        extendJobFailed: null,
        closeJObSuccess: null,
        closeJobFailed: null,
      };
      break;
    case VIEW_JOB_SUCCESS:
      state = {
        ...state,
        loading: false,
        viewJobData: action.payload.viewJob,
        viewJobError: null,
        extendJobSuccess: null,
        extendJobFailed: null,
        closeJObSuccess: null,
        closeJobFailed: null,
      };
      break;
    case VIEW_JOB_ERROR:
      state = {
        ...state,
        loading: false,
        viewJobData: null,
        viewJobError: action.payload.viewJob,
        extendJobSuccess: null,
        extendJobFailed: null,
        closeJObSuccess: null,
        closeJobFailed: null,
      };
      break;
    //Matching candidates

    case GET_MATCHING_CANDIDATE:
      state = {
        ...state,
        matchingCandidateLoader: true,
        matchingJobError: null,
        matchingJobData: null,
      };
      break;
    case GET_MATCHING_JOB_BOARD_CANDIDATE:
      state = {
        ...state,
        matchingJobBoardCandidateLoader: true,
        matchingJobError: null,
        matchingJobBoardCandidateData: null,
      };
      break;
    case GET_MATCHING_CANDIDATE_SUCCESS:
      state = {
        ...state,
        matchingCandidateLoader: false,
        matchingJobData: action.payload.matchingCandidate,
        matchingJobError: null,
      };
      break;
    case GET_MATCHING_JOB_BOARD_CANDIDATE_SUCCESS:
      state = {
        ...state,
        matchingJobBoardCandidateLoader: false,
        matchingJobBoardCandidateData: action.payload.matchingCandidate,
        matchingJobError: null,
      };
      break;
    case GET_MATCHING_CANDIDATE_ERROR:
      state = {
        ...state,
        matchingCandidateLoader: false,
        matchingJobBoardCandidateLoader: false,
        matchingJobData: null,
        matchingJobError: action.payload.matchingCandidate,
      };
      break;
    //Matching candidates Detail

    case GET_MATCHED_CANDIDATE_DETAIL:
      state = {
        ...state,
        loading: true,
        candidateDetailLoader: true,
        matchedCandidateError: null,
        matchedCandidateData: null,
      };
      break;
    case GET_MATCHED_CANDIDATE_DETAIL_SUCCESS:
      state = {
        ...state,
        loading: false,
        candidateDetailLoader: false,
        matchedCandidateData: { data: action.payload.matchedCandidateDetail },
        matchedCandidateError: null,
      };
      break;
    case GET_MATCHED_CANDIDATE_DETAIL_ERROR:
      state = {
        ...state,
        loading: false,
        candidateDetailLoader: false,
        matchedCandidateData: null,
        matchedCandidateError: action.payload.matchedCandidateDetail,
      };
      break;

    // similar jobs
    case GET_SIMILAR_JOB_DETAIL:
      state = {
        ...state,
        similarJobLoader: true,
        similarJobsError: null,
        similarJobsData: null,
      };
      break;
    case GET_SIMILAR_JOB_DETAIL_SUCCESS:
      state = {
        ...state,
        similarJobLoader: false,
        similarJobsData: action.payload.similarJob,
        similarJobsError: null,
      };
      break;
    case GET_SIMILAR_JOB_DETAIL_ERROR:
      state = {
        ...state,
        similarJobLoader: false,
        similarJobsData: null,
        similarJobsError: action.payload.similarJob,
      };
      break;
    // similar selected job detail
    case GET_SELECTED_JOB_DETAIL:
      state = {
        ...state,
        loading: true,
        similarSelectedJobsError: null,
      };
      break;
    case GET_SELECTED_JOB_DETAIL_SUCCESS:
      state = {
        ...state,
        loading: false,
        similarSelectedJobsData: action.payload.selectedJob,
        similarSelectedJobsError: null,
      };
      break;
    case GET_SELECTED_JOB_DETAIL_ERROR:
      state = {
        ...state,
        loading: false,
        similarSelectedJobsData: null,
        similarSelectedJobsError: action.payload.selectedJob,
      };
      break;

    // mapped candidate list
    case GET_MAPPED_JOB_CANDIDATE_DETAIL:
      state = {
        ...state,
        mappedCandidateLoader: true,
        mappedJobCandidateError: null,
      };
      break;
    case GET_MAPPED_JOB_CANDIDATE_DETAIL_SUCCESS:
      state = {
        ...state,
        mappedCandidateLoader: false,
        mappedJobCandidate: action.payload.mappedCandidate,
        mappedJobCandidateError: null,
      };
      break;
    case GET_MAPPED_JOB_CANDIDATE_DETAIL_ERROR:
      state = {
        ...state,
        mappedCandidateLoader: false,
        mappedJobCandidate: null,
        mappedJobCandidateError: action.payload.mappedCandidate,
      };
      break;
    // delete job map detail
    case DELETE_MAPPED_JOB_CANDIDATE:
      state = {
        ...state,
        loading: true,
        deleteMappedCandidateError: null,
      };
      break;
    case DELETE_MAPPED_JOB_CANDIDATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        deleteCandidate: action.payload,
        deleteMappedCandidateError: null,
      };
      break;
    case DELETE_MAPPED_JOB_CANDIDATE_ERROR:
      state = {
        ...state,
        loading: false,
        deleteCandidate: null,
        deleteMappedCandidateError: action.payload,
      };
      break;
    // setMappedCandidate
    case SET_MAPPED_JOB_CANDIDATE_DETAIL:
      state = {
        ...state,
        loading: true,
        setMappedCandidateDetail: null,
        setMappedCandidateError: null,
      };
      break;
    case SET_MAPPED_JOB_CANDIDATE_DETAIL_SUCCESS:
      state = {
        ...state,
        loading: false,
        setMappedCandidateDetail: action.payload,
        deleteMappedCandidateError: null,
      };
      break;
    case SET_MAPPED_JOB_CANDIDATE_DETAIL_ERROR:
      state = {
        ...state,
        loading: false,
        setMappedCandidateDetail: null,
        setMappedCandidateError: action.payload.setMappedCandidate,
      };
      break;
    //Matching candidates Update

    case UPDATE_MAPPED_CANDIDATE:
      state = {
        ...state,
        updateCandidateStatus: true,
        matchedCandidateError: null,
      };
      break;
    case UPDATE_MAPPED_CANDIDATE_SUCCESS:
      state = {
        ...state,
        updateCandidateStatus: false,
        updateMappedSuccess: action.payload.updateMappedCandidate,
        matchedCandidateError: null,
      };
      break;
    case UPDATE_MAPPED_CANDIDATE_ERROR:
      state = {
        ...state,
        updateCandidateStatus: false,
        // matchedCandidateData: null,
        updateMappedSuccess: action.payload.updateMappedCandidate,
      };

      break;
    case CLOSE_JOB:
      state = {
        ...state,
        loading: true,
        closeJObSuccess: null,
        closeJobError: null,
        // matchedCandidateData: null,
      };

      break;
    case CLOSE_JOB_SUCCESS:
      state = {
        ...state,
        loading: false,
        closeJObSuccess: action.payload,
        closeJobError: null,
        // matchedCandidateData: null,
      };

      break;

    case CLOSE_JOB_FAILED:
      state = {
        ...state,
        loading: false,
        closeJObSuccess: null,
        closeJobError: action.payload,
        // matchedCandidateData: null,
      };

      break;
    case EXTEND_JOB:
      state = {
        ...state,
        loading: true,
        extendJobSuccess: null,
        extendJobFailed: null,
        // matchedCandidateData: null,
      };

      break;

    case EXTEND_JOB_SUCCESS:
      state = {
        ...state,
        loading: false,
        extendJobSuccess: action.payload,
        extendJobFailed: null,
        // matchedCandidateData: null,
      };

      break;

    case EXTEND_JOB_FAILED:
      state = {
        ...state,
        loading: false,
        extendJobSuccess: null,
        extendJobFailed: action.payload,
        // matchedCandidateData: null,
      };

      break;
    case OTHER_JOB_DETAILS:
      state = {
        ...state,
        loading: true,
        otherJobDetailsSuccess: null,
        otherJobDetailsFailed: null,
      };

      break;
    case OTHER_JOB_DETAILS_SUCCESS:
      state = {
        ...state,
        loading: false,
        otherJobDetailsSuccess: action.payload,
        otherJobDetailsFailed: null,
      };

      break;
    case OTHER_JOB_DETAILS_FAILED:
      state = {
        ...state,
        loading: false,
        otherJobDetails: null,
        otherJobDetailsFailed: action.payload,
      };

      break;

    //Google Jobs
    case GOOGLE_JOB_DETAILS:
      state = {
        ...state,
        loading: true,
        googleJobsData: null,
        otherJobDetailsFailed: null,
      };

      break;
    case GOOGLE_JOB_DETAILS_SUCCESS:
      state = {
        ...state,
        loading: false,
        googleJobsData: action.payload,
        googleJobdetailsFailed: null,
      };

      break;
    case GOOGLE_JOB_DETAILS_FAILED:
      state = {
        ...state,
        loading: false,
        googleJobsData: null,
        googleJobdetailsFailed: action.payload,
      };

      break;

    case ADD_CANDIDATE:
      state = {
        ...state,
        loading: true,
        addCandidateSuccessMsg: null,
        addCandidateErrorMsg: null,
      };

      break;
    case ADD_CANDIDATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        addCandidateSuccessMsg: action.payload,
        addCandidateErrorMsg: null,
      };

      break;
    case ADD_CANDIDATE_FAILED:
      state = {
        ...state,
        loading: false,
        addCandidateSuccessMsg: null,
        addCandidateErrorMsg: action.payload,
      };

      break;
    //send reminder
    case SEND_CANDIDATE_INTEREST_REMINDER:
      state = {
        ...state,
        loading: true,
        reminder: null,
        erroRemindermsg: null,
      };
      break;

    case SEND_CANDIDATE_INTEREST_REMINDER_SUCCESS:
      state = {
        ...state,
        loading: false,
        reminder: action.payload,
        erroRemindermsg: null,
      };
      break;
    case SEND_CANDIDATE_INTEREST_REMINDER_FAILED:
      state = {
        ...state,
        loading: false,
        reminder: null,
        erroRemindermsg: action.payload,
      };
      break;

    case JOB_LISTING_SUGGESTIONS:
      state = {
        ...state,
        jobTableSuggestionSuccess: null,
        jobTableSuggestionFailed: null,
      };

      break;
    case JOB_LISTING_SUGGESTIONS_SUCCESS:
      state = {
        ...state,
        jobTableSuggestionSuccess: action.payload,
        jobTableSuggestionFailed: null,
      };

      break;
    case JOB_LISTING_SUGGESTIONS_FAILED:
      state = {
        ...state,
        jobTableSuggestionSuccess: null,
        jobTableSuggestionFailed: action.payload,
      };
      break;

    case JOB_STATUS:
      state = {
        ...state,
        jobActive: null,
        jobStatusError: null,
      };
      break;
    case JOB_STATUS_SUCCESS:
      state = {
        ...state,
        jobActive: action.payload,
        jobStatusError: null,
      };

      break;
    case JOB_STATUS_FAILED:
      state = {
        ...state,
        jobActive: null,
        jobStatusError: action.payload,
      };

      break;
    case POST_POPUP_DATA:
      state = {
        ...state,
        popupdata: null,
        erromsg: null,
      };

      break;
    case POST_POPUP_DATA_SUCCESS:
      state = {
        ...state,
        popupdata: action.payload,
        erromsg: null,
      };

      break;
    case POST_POPUP_DATA_FAIL:
      state = {
        ...state,
        popupdata: null,
        erromsg: action.payload,
      };

      break;
    case DELETE_CANDIDATE_ON_CANDIDATEPOOL:
      state = {
        ...state,
        candidateDeleteSucess: null,
        candidateerrormsg: null,
      };
      break;
    case DELETE_CANDIDATE_ON_CANDIDATEPOOL_SUCCESS:
      state = {
        ...state,
        candidateDeleteSucess: action.payload,
        candidateerrormsg: null,
      };
      break;
    case DELETE_CANDIDATE_ON_CANDIDATEPOOL_FAILED:
      state = {
        ...state,
        candidateDeleteSucess: null,
        candidateerrormsg: action.payload,
      };
      break;

    case GENERATE_MATCHING_SCORE_SUCCESS:
      return {
        ...state,
        generateScoreSuccessMsg: action.payload,
        generateScoreErr: null,
      };

    case GENERATE_MATCHING_SCORE_ERROR:
      return {
        ...state,
        generateScoreErr: action.payload,
        generateScoreSuccessMsg: null,
      };

    case GENERATE_BULK_MATCHING_SCORE_SUCCESS:
      return {
        ...state,
        generateBulkScoreSuccessMsg: action.payload,
        generateBulkScoreErr: null,
      };

    case GENERATE_BULK_MATCHING_SCORE_ERROR:
      return {
        ...state,
        generateBulkScoreErr: action.payload,
        generateBulkScoreSuccessMsg: null,
      };

    case BULK_MAP_CANDIDATES_TO_JOB:
      state = {
        ...state,
        bulkMapCandidatesLoading: true,
        bulkMapCandidatesSuccess: null,
        bulkMapCandidatesError: null,
      };
      break;

    case BULK_MAP_CANDIDATES_TO_JOB_SUCCESS:
      state = {
        ...state,
        bulkMapCandidatesLoading: false,
        bulkMapCandidatesSuccess: action.payload,
        bulkMapCandidatesError: null,
      };
      break;

    case BULK_MAP_CANDIDATES_TO_JOB_ERROR:
      state = {
        ...state,
        bulkMapCandidatesLoading: false,
        bulkMapCandidatesSuccess: null,
        bulkMapCandidatesError: action.payload,
      };
      break;

    case GET_DEFAULT_WEIGHTAGE:
      return { ...state, weightageLoading: true, defaultWeightage: null };
    case GET_DEFAULT_WEIGHTAGE_SUCCESS:
      return {
        ...state,
        weightageLoading: false,
        defaultWeightage: action.payload,
      };
    case GET_DEFAULT_WEIGHTAGE_ERROR:
      return { ...state, weightageLoading: false, defaultWeightage: null };

    case GET_CUSTOM_WEIGHTAGE:
      return { ...state, weightageLoading: true };
    case GET_CUSTOM_WEIGHTAGE_SUCCESS:
      return {
        ...state,
        weightageLoading: false,
        customWeightage: action.payload,
      };
    case GET_CUSTOM_WEIGHTAGE_ERROR:
      return { ...state, weightageLoading: false, customWeightage: null };

    case SAVE_CUSTOM_WEIGHTAGE:
      return {
        ...state,
        weightageLoading: true,
        saveWeightageSuccess: null,
        saveWeightageError: null,
      };
    case SAVE_CUSTOM_WEIGHTAGE_SUCCESS:
      return {
        ...state,
        weightageLoading: false,
        saveWeightageSuccess: action.payload,
        saveWeightageError: null,
      };
    case SAVE_CUSTOM_WEIGHTAGE_ERROR:
      return {
        ...state,
        weightageLoading: false,
        saveWeightageSuccess: null,
        saveWeightageError: action.payload,
      };

    // Candidate Facets
    case GET_CANDIDATE_FACETS:
      return {
        ...state,
        facetsLoading: true,
        candidateFacets: null,
        facetsError: null,
      };

    case GET_CANDIDATE_FACETS_SUCCESS:
      return {
        ...state,
        facetsLoading: false,
        candidateFacets: action.payload.facets,
        facetsError: null,
      };

    case GET_CANDIDATE_FACETS_ERROR:
      return {
        ...state,
        facetsLoading: false,
        candidateFacets: null,
        facetsError: action.payload.error,
      };

    case GET_JOB_BASED_FACETS:
      return {
        ...state,
        jobBasedFacetsLoading: true,
        jobBasedFacets: null,
        jobBasedFacetsError: null,
      };

    case GET_JOB_BASED_FACETS_SUCCESS:
      return {
        ...state,
        jobBasedFacetsLoading: false,
        jobBasedFacets: action.payload.facets,
        jobBasedFacetsError: null,
      };

    case GET_JOB_BASED_FACETS_ERROR:
      return {
        ...state,
        jobBasedFacetsLoading: false,
        jobBasedFacets: null,
        jobBasedFacetsError: action.payload.error,
      };

    // Filtered Candidates
    case GET_FILTERED_JOB_BOARD_CANDIDATES:
      return {
        ...state,
        filteredCandidatesLoading: true,
        filteredCandidates: null,
        filteredCandidatesError: null,
      };

    case GET_FILTERED_JOB_BOARD_CANDIDATES_SUCCESS:
      return {
        ...state,
        filteredCandidatesLoading: false,
        filteredCandidates: action.payload.candidates,
        filteredCandidatesError: null,
      };

    case GET_FILTERED_JOB_BOARD_CANDIDATES_ERROR:
      return {
        ...state,
        filteredCandidatesLoading: false,
        filteredCandidates: null,
        filteredCandidatesError: action.payload.error,
      };

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default viewJobReducer;
